import { render, staticRenderFns } from "./ProjectPattern.vue?vue&type=template&id=4a70da9a&scoped=true"
import script from "./ProjectPattern.vue?vue&type=script&lang=js"
export * from "./ProjectPattern.vue?vue&type=script&lang=js"
import style0 from "./ProjectPattern.vue?vue&type=style&index=0&id=4a70da9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70da9a",
  null
  
)

export default component.exports